module.exports = __webpack_public_path__ + "static/media/popup-image.602b19ef.png";